export default {"src":"/_next/static/image/public/images/error_dots_bg.17858fd7b6da98f51980854f60f8d93d.svg","height":331,"width":181};